import { Injectable, Inject} from '@angular/core';


 export  class RequirementChaserDO {

	public id:Number=null;

	public chaserNum:Number=null;
	
	public chaserDt:Date=null;
    
	public statusCd:String=null;
	

	public get $chaserNum(): Number {
		return this.chaserNum;
	}

	public set $chaserNum(value: Number) {
		this.chaserNum = value;
	}

	public get $chaserDt(): Date {
		return this.chaserDt;
	}

	public set $chaserDt(value: Date) {
		this.chaserDt = value;
	}

	public get $statusCd(): String {
		return this.statusCd;
	}

	public set $statusCd(value: String) {
		this.statusCd = value;
	}

}
